import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-modal-user-scoring-edit',
  templateUrl: './modal-user-scoring-edit.component.html',
  styles: []
})
export class ModalUserScoringEditComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  requestLock: boolean = false;
  saveAllowed: boolean = false;
  MONTHNAMES: string[] = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  BonusMalusQuestionare: any = {
    bmqID: '',
    bmqMonth: '',
    bmqYear: '',
    bmq_oeID: '',
    bmqReportQuality: 0,
    bmqProcessingQuality: 0,
    bmqOperationalReadiness: 0,
    bmqSLAObservance: 0,
    bmqComment: ''
  };
  oeName: any = '';
  initial: any = {};

  editMode = false;
  disabled: any;

  yearIndex = 0;
  monthIndex = 0;
  monthselectorList = [] as any[];

  constructor(public modal: ExgModalService, public excSecurity: ExcSecurityService) {
    super();
  }

  ngOnInit(): void {
    this.oeName = this.data.oeName;
    this.editMode = !!this.data.bmqID;
    this.BonusMalusQuestionare.bmqID = this.data.bmqID;
    this.BonusMalusQuestionare.bmq_oeID = this.data.bmq_oeID;
    this.BonusMalusQuestionare.bmqReportQuality = this.data.bmqReportQuality || 0;
    this.BonusMalusQuestionare.bmqProcessingQuality = this.data.bmqProcessingQuality || 0;
    this.BonusMalusQuestionare.bmqOperationalReadiness = this.data.bmqOperationalReadiness || 0;
    this.BonusMalusQuestionare.bmqSLAObservance = this.data.bmqSLAObservance || 0;
    this.BonusMalusQuestionare.bmqComment = this.data.bmqComment || '';
    if (!this.editMode) {
      this.yearIndex = this.data.AvailableDateList.length - 1;
      this.changeYear(this.yearIndex);
      this.monthIndex = this.monthselectorList.length - 1;
      this.changeMonth(this.monthIndex);
    } else {
      this.BonusMalusQuestionare.bmqYear = this.data.bmqYear;
      this.BonusMalusQuestionare.bmqMonth = this.data.bmqMonth;
    }

    this.initial = JSON.parse(JSON.stringify(this.BonusMalusQuestionare));

    this.saveAllowed = (this.editMode && this.excSecurity.isFeatured('BONUSMALUSEDIT')) ||
      (!this.editMode && this.excSecurity.isFeatured('BONUSMALUSCREATE'));
  }

  save(lock: boolean = false) {
    this.BonusMalusQuestionare.Lock = lock;
    this.modal.action({success: true, data: this.BonusMalusQuestionare});
  }

  close() {
    this.modal.close();
  }

  changeYear($event: number) {
    this.yearIndex = $event;
    this.monthselectorList = this.data.AvailableDateList[this.yearIndex].months;
    for (let i in this.monthselectorList) {
      this.monthselectorList[i].monthName = this.MONTHNAMES[this.monthselectorList[i].bmqMonth - 1];
    }
    this.BonusMalusQuestionare.bmqYear = this.data.AvailableDateList[this.yearIndex].bmqYear;
    this.changeMonth(this.monthselectorList.length - 1);
  }

  changeMonth($event: any) {
    this.monthIndex = $event;
    this.BonusMalusQuestionare.bmqMonth = this.monthselectorList[this.monthIndex].bmqMonth;

  }
}
